import { render, staticRenderFns } from "./beautyLaptopView.vue?vue&type=template&id=1487395d&scoped=true&"
import script from "./beautyLaptopView.vue?vue&type=script&lang=js&"
export * from "./beautyLaptopView.vue?vue&type=script&lang=js&"
import style0 from "./beautyLaptopView.vue?vue&type=style&index=0&id=1487395d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1487395d",
  null
  
)

export default component.exports